const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-user-roles'] = {
        c: () => require('partner/modules/eve-user-roles/eve-user-roles.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-user-roles',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-user-roles'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-user-roles|eve-user-roles'] = {
                c: () => require('partner/modules/eve-user-roles/eve-user-roles.view.tsx'),
                cn: '__local__-__local__-eve-user-roles'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };